import { motion, useScroll, useTransform } from "framer-motion";
import { useRef, useEffect, useState, JSXElementConstructor, Key, ReactElement, ReactNode, ReactPortal } from "react";
import styled from "styled-components";


const items = [
    {
        author: "Gary T., Recovering Debater",
        content: "I used to base opinions 'data,' 'logic,' and 'consensus.' Then I met Sebastian. Now I just wait for him to speak so I can be right."
    },
    {
        author: "Kevin S., Certified Believer",
        content: "Sebastian said my car woulden't start cause I had no aura. After I got my money up the car started no problem. He is a visionary."
    },
    {
        author: "Jeff Bezos, CEO of Amazon",
        content: "We hired Sebastian as a consultant and he got up mid-meeting, said 'Blue is better than orange,' and left. Our stock tripled."
    },
    {
        author: "DragonhunterEN",
        content: "I would literally be more comfortable at Little Saint James than if Sebastian invited me to a private island, because at least Epstein can be wrong."
    },
    {
        author: "Argentinian Man",
        content: "When I saw Sebastian was on the Allies side before the nurinberg trials, thats when I knew I had to defect."
    },
    {
        author: "SARF Team",
        content: "Submit your testimonial today!"
    },
]
const Pages = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 1fr auto; 
    gap: 5vh;
    place-items: center;
    padding-bottom: 30vh;
    opacity: 100%;
    width: 100%;
    padding-left: 5vw;
    padding-right: 5vw;
`
const Page = styled.div`
    font-size: 2vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items:center;
    width: 40vw;
    height: 27vh;
    min-height: 300px;
    background-color: #1d181d94;
    border: 2px solid #585858e4;
    color: white;
    padding-left: 2vw;
    padding-right: 2vw;
    opacity: 100%;
    z-index: 0;
`

export function Quotes() {
    return (
            <Pages>
            {items.map((item: { author: any, content: any }) => (
                <Page>
                    "{item.content}"<br/>
                    <br/>
                    -{item.author}
                </Page>
            ))}
        </Pages> 
    )
}
